export default __webpack_public_path__ + "static/media/kitchen4-afterB-1024w.7c95a7e4.png";